import { Link as UiLink, LinkProps, styled } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"

export const Link = styled(UiLink)<LinkProps<typeof RouterLink>>(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing("Base 4/3XS"),
}))